import React from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';
import sizes from 'theme/sizes';

const { lightBackgroundBase, primary } = colors;
const { md } = sizes.fonts;

interface IButtonPrimaryProps {
  backgroundColor?: string;
  border?: string;
  borderRadius?: number;
  color?: string;
  fontSize?: string;
  height?: number;
  onClick?: () => void;
  text: string;
  type?: 'button' | 'submit' | 'reset';
  width?: number | string;
}

const buttonBorderRadius = 3;
const buttonHeight = 34;
const buttonWidth = 93;

const ButtonPrimary = ({
  backgroundColor = primary,
  border = 'none',
  borderRadius = buttonBorderRadius,
  color = lightBackgroundBase,
  fontSize = md,
  height = buttonHeight,
  onClick,
  text,
  type = 'button',
  width = buttonWidth,
}: IButtonPrimaryProps) => {
  const ButtonPrimaryStyled = styled.button({
    border,
    backgroundColor,
    color,
    height,
    fontSize,
    fontWeight: 600,
    borderRadius,
    transition: 'opacity .2s ease-in',
    width,
    opacity: 1,

    '&:hover': {
      cursor: 'pointer',
      opacity: 0.8,
    },
  });

  return (
    <ButtonPrimaryStyled type={type} onClick={onClick}>
      {text}
    </ButtonPrimaryStyled>
  );
};

export default ButtonPrimary;
